import {IOrganization} from "./organization.model";

export interface IInstaller {
  id?: number;
  firstName?: string;
  lastName?: string;
  title?: string;
  phone?: string;
  fieldActivity?: string;
  address?: string;
  description?: string;
  status?: string;
  isdeleted?: boolean;
  isarchived?: boolean;
  organization?: IOrganization;
  createdBy?: string;
  createdDate?: any;
}

export class Installer implements IInstaller {
  constructor(public id?: number) {
  }
}
